import React, { Component } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import Popover from 'components/shared/popover';
import Badge from 'components/shared/Badge';

class LabsBadge extends Component {
  static FeedbackMessage = () => (
    <p>
      {t('common.labs.feedback_description')}{' '}
      <a className="td-u" href={`mailto:${t('common.feedback_email')}`}>
        {t('common.feedback_email')}
      </a>
    </p>
  );

  constructor(props) {
    super(props);
    this.state = {
      popoverVisible: false,
    };
    this.togglePopover = this.togglePopover.bind(this);
  }

  togglePopover() {
    this.setState(state => ({ popoverVisible: !state.popoverVisible }));
  }

  render() {
    const {
      className,
      title,
      children,
      dark,
      tagText = t('common.labs.name'),
      showIcon = true,
      larger,
      rounded,
    } = this.props;
    return (
      <div className={classNames('ff-ss pos-r f-smooth', className)}>
        <Badge
          className={children ? 'c-p' : ''}
          onClick={children ? this.togglePopover : null}
          dark={dark}
          larger={larger}
          rounded={rounded}
        >
          {tagText} {showIcon && <Icon name="info" className="ml-2" />}
        </Badge>
        {children && this.state.popoverVisible && (
          <Popover dismissCallback={this.togglePopover}>
            {title && <h4 className="fw-b ff-ss mb-16">{title}</h4>}
            <div className="c-gray-dark">{children}</div>
          </Popover>
        )}
      </div>
    );
  }
}

export default LabsBadge;
